import { useQuery } from '@apollo/client/react';

import { LoggerContextProps } from '../types/LogContext';
import { GET_CASE } from '../queries/GetCase';
import { UseHookOptions } from '../types/UseHookOptions';
import { handleError } from './errorHandler';
import { Case } from '../types/Case';

interface UseGetCaseOptions extends UseHookOptions {
  id?: string;
}

export function useGetCase(options: UseGetCaseOptions = {}) {
  const context: LoggerContextProps = {
    action: 'getCase',
    caseId: options.id || '',
  };
  const { useCache = true, id } = options;

  const { data, loading, error, refetch } = useQuery<{
    getCase: Case;
  }>(GET_CASE, {
    variables: id ? { input: id } : undefined,
    skip: !id,
    fetchPolicy: useCache ? 'cache-first' : 'no-cache',
    notifyOnNetworkStatusChange: true,
  });

  const getCase = async (caseId: string) => {
    context.caseId = caseId;
    try {
      await refetch({ input: caseId });
    } catch (error) {
      handleError(error, context, 'Failed to get case.');
    }
  };

  return { getCase, refetch, data, loading, error };
}
